import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import "../styles/Search.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import locales from "../../../_constants/locales";
import { trackEvent } from "../../../_utils/GoogleAnalytics";

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order_no: "",
            order_no_error_message: "",
            email: "",
            email_error_message: ""
        };
    }

    getOrderNumberPlaceholder() {
        return this.props.store && this.props.store[0] && `${this.getValidStorePlaceholder()}12345`;
    }

    getValidStorePlaceholder() {
        return this.props.store && this.props.store[0] && (this.props.store[0] === "CORPORATE" ? "CORP" : this.props.store[0]);
    }

    orderNumberValid(order_number) {
        let storeRegEx = null;

        if (this.props.store && this.props.store.length >= 1) {
            storeRegEx = `(${this.props.store.join("|")})`;
        }

        var regex = new RegExp("^" + storeRegEx + "[0-9]+$");

        return regex.test(order_number.trim().toUpperCase());
    }

    emailValid(email) {
        var regex = RegExp(".+@.+\\..+");
        return regex.test(email.trim());
    }

    getViewQueryParameters() {
        let search = this.props.location.search;

        if (search) {
            let params = search.substring(1, search.length).split("&");

            var store = [];

            for (let index = 0; index < params.length; index++) {
                let q = params[index].split("=");

                if (q[0].toUpperCase() === "STORE" && q[1] !== "") {
                    q[1]
                        .toUpperCase()
                        .split(",")
                        .forEach(e => {
                            if (this.props.store_list.indexOf(e) >= 0) {
                                store.push(e);
                            }
                        });
                } else if (q[0].toUpperCase() === "LANGUAGE" && q[1] !== "") {
                    if (this.props.language_list.indexOf(q[1].toUpperCase()) >= 0) {
                        this.props.setLanguage(q[1].toUpperCase());
                    }
                }
            }

            if (store.length > 0) {
                this.props.setStore(store);
            }
        }
    }

    componentDidMount() {
        this.props.resetLanguage();
        this.props.resetStore();

        if (this.props.language_list.length === 0) {
            this.props.getLanguages();
        }

        if (this.props.store_list.length === 0) {
            this.props.getStores();
        }

        this.getViewQueryParameters();

        if (this.props.search_results !== null && !_.isEmpty(this.props.search_results)) {
            this.props.resetSearchResult();
        }

        this.postMessageToParentWindow();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.search_order_id !== this.props.search_order_id && !_.isEmpty(this.props.search_results) && this.props.search_order_id !== null) {
            trackEvent("Search", "Search Order", "true");
            this.props.history.push(`/embedded/orders/${this.props.search_order_id}?store=${this.props.store}&language=${this.props.language}`);
        }

        if (
            (prevProps.search_order_no !== this.props.search_order_no || prevProps.search_email !== this.props.search_email) &&
            this.props.search_order_id === null
        ) {
            trackEvent("Search", "Search Order", "false");
            this.props.updateSearchMessage(locales[this.props.store[0]][this.props.language].SEARCH_PAGE.FEEDBACK_MESSAGE.ORDER_NOT_FOUND);
        }

        if (this.props.language_list !== prevProps.language_list || this.props.store_list !== prevProps.store_list) {
            this.getViewQueryParameters();
        }

        if (prevProps.loading === true && this.props.loading === false && this.props.searchError) {
            this.props.updateSearchMessage(locales[this.props.store[0]][this.props.language].SEARCH_PAGE.FEEDBACK_MESSAGE.ORDER_NOT_FOUND);
        }

        this.postMessageToParentWindow();
    }

    postMessageToParentWindow() {
        let rootElement = document.getElementById("root");
        let height = Math.max(rootElement.scrollHeight, rootElement.offsetHeight, rootElement.clientHeight);

        let data = {
            action: "SITE_UPDATED",
            height
        };
        window.parent.window.postMessage(JSON.stringify(data), "*");
    }

    handleInputChange(input_name, e) {
        this.setState({ [input_name]: e.target.value });
        if (this.state[`${input_name}_error_message`]) {
            this.setState({ [`${input_name}_error_message`]: "" });
        }
    }

    handleForgotOrderNoClick() {
        this.props.resetSearchMessage();
        trackEvent("Search", "Forgot Order", "true");
        this.props.history.push(`/embedded/search/forgot-order-no?store=${this.props.store}&language=${this.props.language}`);
    }

    resetErrorMessages() {
        this.setState({
            order_no_error_message: "",
            email_error_message: ""
        });
    }

    handleSearch() {
        this.props.resetSearchResult();
        this.props.resetSearchMessage();
        this.resetErrorMessages();

        var inputs_valid = true;

        if (!this.state.order_no) {
            inputs_valid = false;
            this.setState({
                order_no_error_message: locales[this.props.store[0]][this.props.language].SEARCH_PAGE.ORDER_NUMBER_INPUT.ERROR_REQUIRED
            });
        } else {
            if (!this.orderNumberValid(this.state.order_no)) {
                inputs_valid = false;

                this.setState({
                    order_no_error_message: `${
                        locales[this.props.store[0]][this.props.language].SEARCH_PAGE.ORDER_NUMBER_INPUT.ERROR_INVALID_FORMAT
                    } ${this.getOrderNumberPlaceholder()}`
                });
            }
        }

        if (!this.state.email) {
            inputs_valid = false;
            this.setState({
                email_error_message: locales[this.props.store[0]][this.props.language].SEARCH_PAGE.EMAIL_ADDRESS_INPUT.ERROR_REQUIRED
            });
        } else {
            if (!this.emailValid(this.state.email)) {
                inputs_valid = false;
                this.setState({
                    email_error_message: locales[this.props.store[0]][this.props.language].SEARCH_PAGE.EMAIL_ADDRESS_INPUT.ERROR_INVALID
                });
            }
        }

        if (inputs_valid) {
            this.props.search(this.state.order_no, this.state.email, this.props.store);
        }
    }

    render() {
        return (
            <section className="flex layout horizontal center-center">
                {this.props.language_list_loading || this.props.store_list_loading ? (
                    <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                ) : (
                    <div className="flex layout vertical search-main-frame search">
                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <h1 className="frame-heading">{locales[this.props.store[0]][this.props.language].SEARCH_PAGE.HEADING}</h1>
                                </div>
                            </div>
                        </div>
                        {this.props.search_message && (
                            <div className="box">
                                <div className="row">
                                    <div className="column">
                                        <div className="message-box">{this.props.search_message}</div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <div className="input-box">
                                        <div className="flex layout justified horizontal">
                                            <div className="input-heading">
                                                * {locales[this.props.store[0]][this.props.language].SEARCH_PAGE.ORDER_NUMBER_INPUT.HEADER}
                                            </div>
                                        </div>
                                        <div className="flex layout horizontal">
                                            <input
                                                onChange={this.handleInputChange.bind(this, "order_no")}
                                                className="custom-input"
                                                placeholder={this.getOrderNumberPlaceholder()}
                                            />
                                        </div>
                                        <div className="flex input-error-box">
                                            <div className="input-heading">{this.state.order_no_error_message}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="column">
                                    <div className="input-box">
                                        <div className="flex">
                                            <div className="input-heading">
                                                * {locales[this.props.store[0]][this.props.language].SEARCH_PAGE.EMAIL_ADDRESS_INPUT.HEADER}
                                            </div>
                                        </div>
                                        <div className="flex layout horizontal">
                                            <input
                                                onChange={this.handleInputChange.bind(this, "email")}
                                                className="custom-input"
                                                placeholder="name@domain.com"
                                            />
                                        </div>
                                        <div className="flex input-error-box">
                                            <div className="input-heading">{this.state.email_error_message}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <div className="layout horizontal justified center-center">
                                        <button
                                            className={`custom-button view-order layout horizontal center-center ${this.props.loading ? "loading" : ""}`}
                                            onClick={this.props.loading ? null : this.handleSearch.bind(this)}
                                        >
                                            <div className="layout vertical center-center inbutton-text">
                                                {this.props.loading || this.props.language_list_loading || this.props.store_list_loading ? (
                                                    <CircularProgress size={24} className="circular-loading" thickness={6} />
                                                ) : (
                                                    locales[this.props.store[0]][this.props.language].SEARCH_PAGE.SEARCH_BUTTON_TEXT
                                                )}
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <div className="forgot-order-no-input-box">
                                        <a className="input-heading linked-text" onClick={this.handleForgotOrderNoClick.bind(this)}>
                                            {locales[this.props.store[0]][this.props.language].SEARCH_PAGE.FORGOT_YOUR_ORDER_NUMBER}?
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        );
    }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/views/Search/components/Search.jsx